<template>
  <DashboardTemplate :navMenu="true" class="custom-activity">
    <div class="pd-b-4">
      <div class="text-left">
        <h2 class="mg-less">ภาพรวมคะแนนหลักสูตร</h2>
      </div>
      <div
        class="flex-display js-between ai-center search-download change-display"
      >
        <div class="flex-display change-display text-left">
          <p class="text-font-14">
            <span class="text-weight-bold">หลักสูตร </span
            ><span class="color-gray">{{ course.name }}</span>
          </p>
          <p class="text-font-14 pd-l-4">
            <span class="text-weight-bold">วิชาที่</span> {{ subject.index }}
            <span class="color-gray">{{ subject.name }}</span>
          </p>
        </div>
        <div class="flex-display js-end change-display">
          <el-form @submit.prevent.native @keyup.enter.native="search">
            <el-input
              placeholder="ค้นหารายชื่อ"
              prefix-icon="el-icon-search"
              class="search-input"
              @blur="
                (showInputSearch = false),
                  !searchText && showSearch ? search() : null
              "
              @keyup.enter.native="search"
              @clear="(searchText = ''), search()"
              :class="{ show: showInputSearch }"
              clearable
              ref="search"
              v-model="searchText"
            >
            </el-input>

            <el-button
              v-if="!showInputSearch"
              @click="openSearchInput"
              icon="el-icon-search"
              round
              class="pd-x-2 primary border-color-primary"
              >ค้นหา</el-button
            >
          </el-form>
          <el-button @click="csvExport" type="primary" class="mg-l-4" round
            >ดาวน์โหลดข้อมูล</el-button
          >
        </div>
      </div>
    </div>
    <div v-if="showSearch" class="text-left pd-b-3">
      <p class="mg-y-less">
        <span class="text-weight-600">ค้นหา</span> “{{ searchText }}”
      </p>
    </div>
    <div>
      <ActivitySummaryScore
        v-loading="loading"
        :nameList="nameList"
        :courseId="courseId"
        :subjectId="subjectId"
        :page="page"
        :pageSize="pageSize"
        @checkAssignment="checkAssignment"
      />
    </div>

    <div v-if="totalNameList > 10" class="pd-y-3">
      <el-pagination
        @current-change="changePage"
        background
        layout="prev, pager, next"
        :total="totalNameList"
        :page-size="pageSize"
        :current-page="page"
      ></el-pagination>
    </div>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import ActivitySummaryScore from "@/components/activity/ActivitySummaryScore";
import { HTTP } from "@/service/axios.js";

export default {
  props: {
    routeParams: {
      type: Object,
      default: null,
    },
  },
  components: {
    DashboardTemplate,
    ActivitySummaryScore,
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    courseList() {
      return this.$store.state.courseList;
    },
  },
  data() {
    return {
      loading: true,
      courseId: "",
      subjectId: "",
      nameList: [],
      searchText: "",
      showInputSearch: false,
      course: "",
      subject: "",
      page: 1,
      pageSize: 10,
      showSearch: false,
      totalNameList: 0,
      nameListAll: [],
    };
  },
  mounted() {
    this.setParams();
    this.fetchCourseList();
    this.fetchStudentScore();
    this.fetchStudentScoreAll();
  },
  methods: {
    csvExport() {
      let columnsTemplate = [
        "ลำดับ",
        "ชื่อ",
        "นามสกุล",
        "ชื่อหน่วยงาน",
        "แบบทดสอบก่อนเรียน",
        "กระดานถาม-ตอบระหว่างเรียน",
        "งานที่ได้รับมอบหมาย",
        "แบบทดสอบหลังเรียน",
        "วีดีโอ",
        "อัปเดทล่าสุดเมื่อ",
      ];

      let title = [];
      for (let index = 0; index < columnsTemplate.length; index++) {
        title.push(columnsTemplate[index]);
      }

      let data = [];
      for (let index = 0; index < this.nameListAll.length; index++) {
        let notOpen =
          Date.now() < new Date(this.nameListAll[index].score.open).getTime();

        let preTest = notOpen
          ? "วิชายังไม่เปิด"
          : this.nameListAll[index].score.preTestDone
          ? `${this.nameListAll[index].score.preTestScore} เต็ม ${this.nameListAll[index].score.preTestTotal}`
          : "ยังไม่ได้ทำข้อสอบ";

        let discussion = notOpen
          ? "วิชายังไม่เปิด"
          : !this.nameListAll[index].score.haveDiscussion
          ? "-"
          : this.nameListAll[index].score.discussion
          ? `ตอบคำถามแล้ว`
          : "ยังไม่ได้ตอบคำถาม";

        let assignment = notOpen
          ? "วิชายังไม่เปิด"
          : !this.nameListAll[index].score.haveAssignment
          ? "-"
          : !this.nameListAll[index].score.takeAssignment
          ? `ยังไม่ได้ส่ง`
          : this.nameListAll[index].score.assignment == 0
          ? "ยังไม่ได้ตรวจ"
          : "ตรวจแล้ว";

        let postTest = notOpen
          ? "วิชายังไม่เปิด"
          : !this.nameListAll[index].score.havePostTest
          ? "-"
          : this.nameListAll[index].score.postTestDone
          ? `${this.nameListAll[index].score.postTestScore} เต็ม ${this.nameListAll[index].score.postTestTotal}`
          : "ยังไม่ได้ทำข้อสอบ";

        let topic = notOpen
          ? "วิชายังไม่เปิด"
          : !this.nameListAll[index].score.haveTopic
          ? "-"
          : this.nameListAll[index].score.topic >= 100
          ? `ดูวีดีโอแล้ว`
          : this.nameListAll[index].score.takeTopic
          ? "กำลังเรียน"
          : "ยังไม่ได้เรียน";

        let obj = {
          index: index + 1,
          nameTH: this.nameListAll[index].nameTH
            ? '"' + this.nameListAll[index].nameTH + '"'
            : null,
          surnameTH: this.nameListAll[index].surnameTH
            ? '"' + this.nameListAll[index].surnameTH + '"'
            : null,
          company: this.nameListAll[index].companyName
            ? '"' + this.nameListAll[index].companyName + '"'
            : null,
          preTest: '"' + preTest + '"',
          discussion: '"' + discussion + '"',
          assignment: '"' + assignment + '"',
          postTest: '"' + postTest + '"',
          topic: '"' + topic + '"',
          updatedAt: this.$options.filters.dateTimeTh(
            this.nameListAll[index].updatedAt
          ),
        };
        data.push(obj);
      }

      let csvContent = "";
      csvContent += [
        title.join(","),
        ...data.map((item) => Object.values(item).join(",")),
      ]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");

      var link = window.document.createElement("a");
      link.setAttribute(
        "href",
        "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csvContent)
      );

      let dataFile =
        "ภาพรวมคะแนนหลักสูตร_" +
        new Date().getDate() +
        "-" +
        (new Date().getMonth() + 1) +
        "-" +
        new Date().getFullYear();
      link.setAttribute("download", dataFile + ".csv");
      link.click();
    },
    fetchCourseList() {
      let obj = {
        token: this.token,
      };
      this.$store.dispatch("FETCH_COURSE_LIST", obj);
      let filter = this.courseList.filter(
        (filter) => filter._id == this.courseId
      );

      if (filter.length > 0) {
        this.course = filter[0];
        let course = filter[0].subject.filter(
          (filter) => filter._id == this.subjectId
        );
        if (course.length > 0) {
          this.subject = course[0];
        }
      }
    },
    setParams() {
      if (this.routeParams != null) {
        if (typeof this.routeParams.courseId != "undefined") {
          this.courseId = this.routeParams.courseId;
          this.subjectId = this.routeParams.subjectId;
        }
      }
    },
    fetchStudentScoreAll() {
      let obj = {
        courseId: this.courseId,
        subjectId: this.subjectId,
        page: 0,
        limit: 0,
        search: "",
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`get/student/score/subject`, obj).then((res) => {
        if (res.data.success) {
          this.nameListAll = res.data.obj;
        }
      });
    },
    fetchStudentScore() {
      let obj = {
        courseId: this.courseId,
        subjectId: this.subjectId,
        page: (this.page - 1) * this.pageSize,
        limit: this.pageSize,
        search: this.searchText,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`get/student/score/subject`, obj)
        .then((res) => {
          if (res.data.success) {
            this.nameList = res.data.obj;
            this.totalNameList = res.data.count;
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("fetchStudentScore error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    openSearchInput() {
      this.showInputSearch = true;
      if (!this.showSearch) {
        this.searchText = "";
      }

      setTimeout(() => {
        this.$refs.search.focus();
      }, 500);
    },
    search() {
      this.loading = true;
      this.page = 1;
      this.fetchStudentScore();
      if (this.searchText != "") {
        this.showSearch = true;
      } else {
        this.showSearch = false;
      }
    },
    checkAssignment(userId, subjectId, status) {
      this.loading = true;

      let obj = {
        subjectId: subjectId,
        userId: userId,
        status: status == 100 ? false : true,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`check/assignment`, obj)
        .then((res) => {
          if (res.data.success) {
            this.fetchStudentScore();
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("checkAssignment error", e);
        });
    },
    changePage(page) {
      this.loading = true;
      this.page = page;
      this.fetchStudentScore();
    },
  },
};
</script>